const ItemLotSearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Warehouse",
                "tableName": "",
                "label": "Warehouse",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "LotSubclasscode",
                "tableName": "",
                "label": "Lot Subclasscode",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Lotcode",
                "tableName": "",
                "label": "Lot",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "LotOversellpercentage",
                "tableName": "LotOversellpercentage",
                "label": "Lot Over Sell Percentage:",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "LotDescription",
                "tableName": "",
                "label": "Lot Description",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "Itemcode",
                "tableName": "",
                "label": "Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "LotClasscode",
                "tableName": "",
                "label": "Lot Classcode",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "ItemDescription",
                "tableName": "",
                "label": "Item Description",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": true,
                "visible": true

            }
        ]
    }
];
export default ItemLotSearchFormLayout;